'use strict';

var FareOptimizerAnalysisPanelController = function FareOptimizerAnalysisPanelController($scope) {
  $scope.expandFilter = function () {
    $scope.screenState.sideFilterExpanded = true;
  };
};
FareOptimizerAnalysisPanelController.$inject = ['$scope'];
module.exports = FareOptimizerAnalysisPanelController;